import type { Locale } from '~/i18n/i18n-config';

const LONDON_ORIGIN_ID = 26;
const AMSTERDAM_ORIGIN_ID = 22_370_654;

// The trip origin used when a visitor hasn't chosen one. Locales not listed fall back to London.
const DEFAULT_ORIGIN_ID_BY_LOCALE: Partial<Record<Locale, number>> = {
  'nl-NL': AMSTERDAM_ORIGIN_ID
};

export const DEFAULT_ORIGIN_ID = LONDON_ORIGIN_ID;

export function getDefaultOriginId(locale?: string): number {
  return DEFAULT_ORIGIN_ID_BY_LOCALE[locale as Locale] ?? DEFAULT_ORIGIN_ID;
}

export const DEFAULT_BUILD_NIGHTS = '9';

/** Search params for a bare `/map/build` entry: `?origin=<id>&nights=9`. */
export function getDefaultBuildSearch(locale?: string): string {
  return `?origin=${getDefaultOriginId(locale)}&nights=${DEFAULT_BUILD_NIGHTS}`;
}
